(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('ReportsController', ReportsController);

  /* ngInject */
  function ReportsController($window, branchService, config, reportFormats, reportNames, reportService, riskLevels, sessionService) {
    const vm = this;

    vm.branches = [];
    vm.generateReport = generateReport;
    vm.include_all_branches = true;
    vm.loaded = false;
    vm.report = [];
    vm.reportFormat = 'html';
    vm.reportFormats = reportFormats;
    vm.reportName = 'Assigned Tasks';
    vm.reportNames = reportNames;
    vm.reset = reset;
    vm.riskLevels = riskLevels;
    vm.sessionService = sessionService;

    activate();

    function activate() {
      getBranches();
    }

    function getBranches() {
      branchService(sessionService.getAuthToken()).query({}, response => {
        vm.branches = response;

        if (vm.branches.length) {
          vm.branchId = vm.branches[0].id;
        }
      });
    }

    function generateReport() {
      let params = {
        'report_request': {
          'report_name': vm.reportName,
          'report_format': vm.reportFormat,
          'report_branch': vm.branchId,
          'risk_level': vm.riskLevel,
          'start_date': vm.start_date,
          'end_date': vm.end_date,
          'include_inactive': vm.include_inactive ? 1 : 0,
          'include_all_branches': vm.include_all_branches ? 1 : 0
        }
      };

      reportService(sessionService.getAuthToken()).create(params, response => {
        vm.report = response;
        vm.loaded = true;
      });
    }

    function reset() {
      vm.loaded = false;
      vm.report = [];
    }
  }
})();
